import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';

const Eventos = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
  }, []);

  const handleClose = () => setShow(false);

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>¡B!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>¡Nos alegra verte!.</p>
        <img src={`${process.env.PUBLIC_URL}/toponimio.png`} alt="Bienvenida" style={{ width: '100%' }} />
        <p>Aquí encontrarás toda la información que necesitas sobre nuestro municipio.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Eventos;